import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
    IDealershipUIConfiguration,
    ISocialMedia,
} from "../../modules/dealer/interfaces/IDealershipUIConfiguration";
import DCPCustomizationAPI from "../../API/DCPCustomizationAPI";
import { toast } from "react-toastify";
import { DCPDefaultTheme } from "../../utilities/Constants";

interface IDealershipUIConfigurationState {
    dealershipUIConfigurations: IDealershipUIConfiguration; // changeable via ui
    dealershipTabIcon: string;
    dealershipUIConfigurationDbValues: IDealershipUIConfiguration; // db values to set on cancel command
}

export const initialSocialMedia: ISocialMedia = {
    facebookUrl: "",
    instagramUrl: "",
    linkedInUrl: "",
    twitterXUrl: "",
    youTubeUrl: "",
    tikTokUrl: "",
    websiteUrl: "",
};

export const initialDealershipUIConfigurations: IDealershipUIConfiguration = {
    id: 0,
    mainColor: DCPDefaultTheme.MAIN_COLOR,
    textColor: DCPDefaultTheme.TEXT_COLOR,
    buttonColor: DCPDefaultTheme.BUTTON_COLOR,
    primaryColor: DCPDefaultTheme.PRIMARY_COLOR,
    contentTextColor: DCPDefaultTheme.CONTENT_TEXT_COLOR,
    logo: "",
    logoBase64: "",
    tabIcon: "",
    tabIconBase64: "",
    socialMedia: initialSocialMedia as ISocialMedia,
};

const initialState: IDealershipUIConfigurationState = {
    dealershipUIConfigurations: initialDealershipUIConfigurations,
    dealershipTabIcon: "",
    dealershipUIConfigurationDbValues: initialDealershipUIConfigurations,
};

export const ThemeSlice = createSlice({
    name: "theme",
    initialState,
    reducers: {
        // Set State
        SET_DEALERSHIP_UI_CONFIGURATIONS: (state, action) => {
            state.dealershipUIConfigurations = action.payload;
        },
        SET_DEALERSHIP_TAB_ICON: (state, action) => {
            state.dealershipTabIcon = action.payload;
        },
        SET_DEALERSHIP_UI_CONFIGURATIONS_DB_VALUES: (state, action) => {
            state.dealershipUIConfigurationDbValues = action.payload;
        },
        RESET_DEALERSHIP_UI_CONFIGURATIONS: (state) => {
            state.dealershipUIConfigurations =
                state.dealershipUIConfigurationDbValues;
        },
    },
});

// Actions

export const fetchDealershipUIConfigurations = createAsyncThunk(
    "customisation/get",
    async (_: void, { dispatch }) => {
        await DCPCustomizationAPI.getDealershipUIConfigurations()
            .then((res) => {
                dispatch(
                    SET_DEALERSHIP_UI_CONFIGURATIONS(
                        res?.data?.data as IDealershipUIConfiguration
                    )
                );
                dispatch(
                    SET_DEALERSHIP_UI_CONFIGURATIONS_DB_VALUES(
                        res?.data?.data as IDealershipUIConfiguration
                    )
                );
            })
            .catch((_err) => {
                if (
                    _err.response.data.messages[0] &&
                    _err.response.data.messages[0] !==
                        "Dealership not Found." &&
                    _err.response.data.messages[0] !==
                        "Portal Configurations not Found."
                ) {
                    toast.error(_err.response.data.messages[0] ?? _err.message);
                }
                dispatch(
                    SET_DEALERSHIP_UI_CONFIGURATIONS(
                        initialDealershipUIConfigurations as IDealershipUIConfiguration
                    )
                );
                dispatch(
                    SET_DEALERSHIP_UI_CONFIGURATIONS_DB_VALUES(
                        initialDealershipUIConfigurations as IDealershipUIConfiguration
                    )
                );
            });
    }
);

export const fetchDealershipCustomTabIcon = createAsyncThunk(
    "customisation/get-dealership-custom-tab-icon",
    async (dealershipId: string, { dispatch }) => {
        await DCPCustomizationAPI.getDealershipCustomTabIcon(dealershipId)
            .then((res) => {
                dispatch(SET_DEALERSHIP_TAB_ICON(res?.data?.data as string));
            })
            .catch(() => {
                dispatch(SET_DEALERSHIP_TAB_ICON(""));
            });
    }
);

export const {
    SET_DEALERSHIP_UI_CONFIGURATIONS,
    SET_DEALERSHIP_TAB_ICON,
    SET_DEALERSHIP_UI_CONFIGURATIONS_DB_VALUES,
    RESET_DEALERSHIP_UI_CONFIGURATIONS,
} = ThemeSlice.actions;

export default ThemeSlice.reducer;
